export default "__VITE_ASSET__mpK1b8aK__"